import React from "react";
import ModalComponent from "./Modal";
import { Typography } from "@mui/material";
import { Box } from "@mui/material";
import { Button } from "@mui/material";
import { useStore } from "../../store/useStore";

const InstructionsModal = ({ openModal, data, setTimerVisible, setOpenModal, startApplication, appState }) => {
  const { applicacionData } = useStore();
  const name = applicacionData?.name || data?.application?.name || "Aplicación";
  const instructions = applicacionData?.instructions || data?.application?.instructions;

  const decodeEscapedHtml = (str) => {
    return str
      .replace(/\\u003c/g, "<")
      .replace(/\\u003e/g, ">")
      .replace(/\\u0022/g, '"')
      .replace(/\\u0027/g, "'")
      .replace(/\\n/g, "\n");
  };

  const decodedHtml = instructions ? decodeEscapedHtml(instructions) : "";

  if (!instructions) {
    return null;
  }

  return (
    <ModalComponent open={openModal} handleClose={() => setOpenModal(false)}>
      <Typography id="modal-modal-title" variant="h5" component="h2">
        {name}:
      </Typography>
      <Box
        sx={{
          mt: 2,
          maxHeight: "60vh",
          overflowY: "auto",
          fontFamily: "Arial, sans-serif",
          lineHeight: "1.6",
          color: "#333",
          textAlign: "justify",
        }}
      >
        <div dangerouslySetInnerHTML={{ __html: decodedHtml }} />
      </Box>
      <Box
        sx={{ display: "flex", justifyContent: "end", mt: 2 }}
        onClick={() => {
          setTimerVisible(true);
          setOpenModal(false);
        }}
      >
        <Button variant="contained">{startApplication && appState !== "Incompleto" ? "Empezar" : "Continuar"}</Button>
      </Box>
    </ModalComponent>
  );
};

export default InstructionsModal;
